export default "__VITE_ASSET__c41190a3__"